import { type UseQueryResult, useQuery } from 'react-query';
import {
  ParticipantBankService,
  // eslint-disable-next-line camelcase
  type PagedResultDto_ParticipantBankListDto,
} from '../../services/wealthlane-finance-integration-services';
import { type TableParamsType } from '../../types/common';

const useGetCompanyBankList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_ParticipantBankListDto | undefined,
  unknown
> => {
  const { filter, sorting, skipCount, maxResultCount } = tableInfo;
  const companyBankList = useQuery(
    ['getCompanyBankList', filter, sorting, skipCount, maxResultCount],
    async () => {
      return await handleRequest(
        ParticipantBankService.getApiFinanceIntegrationApiAppParticipantBankParticipantBankList(
          filter,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    },
    {
      select: (data) => {
        if (data != null) {
          return data;
        }
      },
      cacheTime: 1000 * 60 * 5,
    }
  );

  return companyBankList;
};

export default useGetCompanyBankList;
